import { render, staticRenderFns } from "./system-update-detail.html?vue&type=template&id=f70b05f0&scoped=true&external"
import script from "./system-update-detail.js?vue&type=script&lang=js&external"
export * from "./system-update-detail.js?vue&type=script&lang=js&external"
import style0 from "./system-update-detail.scss?vue&type=style&index=0&id=f70b05f0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70b05f0",
  null
  
)

export default component.exports